import { defineComponent as _defineComponent } from 'vue'
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { usePostbacks, PostbacksColumns } from "@/services/TablePage/postbacks";
import { ref, onMounted } from "vue";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import PostbacksConstructor from "@/components/statistics/postbacks/PostbacksConstructor.vue";
import { getPostbacks } from "@/api/autostats";
import { getCurrentDate } from "@/utils/formatDates";
import { downloadFileToDisk } from "@/api";
import { showServerError } from "@/utils";
import { useRoute } from "vue-router/composables";
import store from "@/store";
import { FormattedItem } from "@/utils/CellsFactory";
import { IPostback } from "@/api/types/autostats";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostbacksList',
  setup(__props) {

const { getHeaders, getFormattedItems } = usePostbacks();
const headers = getHeaders();
const isLoading = ref(false);
const offset = ref(0);
const total = ref(0);
const route = useRoute();
const constructor = ref(null);
const preparedItems = ref<FormattedItem<IPostback>[]>([]);

onMounted(() => {
    getReport();
});

const tableComp = ref(null);

const changePageFromConstructor = () => {
    changePage(0);
    if (tableComp.value) {
        tableComp.value.scrollToTop();
    }
};

const changePage = (value: number) => {
    offset.value = value;
    getReport();
};

const getReport = async () => {
    try {
        isLoading.value = true;
        const params = getParams();
        params.offset = offset.value;
        if (!!params.fields && !params.fields.includes('postback_id')) {
            params.fields += ',postback_id';
        }
        const { data, meta } = await getPostbacks(params);
        total.value = meta?.total!;
        const items = getFormattedItems(data);
        items.forEach((i, index) => i.id = data[index].postback_id);
        preparedItems.value = items;
    } catch (err) {
        showServerError(err, 'Список постбеков не загружен');
    } finally {
        isLoading.value = false;
    }
};

const isExportLoading = ref(false);
const exportPostbacks = async () => {
    try {
        isExportLoading.value = true;
        const params = getParams();
        const file = await getPostbacks(params, true);
        const today = getCurrentDate('dd.MM.yyyy');
        const name = `postbacks_${today}`;
        downloadFileToDisk(file, { name, extension: 'xlsx' });
    } catch (err) {
        showServerError(err, 'Не удалось скачать выгрузку');
    } finally {
        isExportLoading.value = false;
    }
};

const getParams = () => {
    const params = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
    const columns = (constructor?.value?.selected! || route.query.columns) as string[];
    if (columns && (columns.includes('goal_id') || columns.includes('goal_name')) && !columns.includes('goal_inner_id')) {
        columns.push('goal_inner_id');
    }
    prepareFilters(params);
    params.fields = columns ? columns.join(',') : undefined;

    if( !params.postback_date_from || !params.postback_date_to ){
        const defaultColumns = new PostbacksColumns().columns.flatMap(i => i.items.filter(j => j.default).map(k => k.value)).join();
        params.fields = "postback_id," + defaultColumns;
        params.postback_date_from = getCurrentDate('yyyy-MM-dd') + ' 00:00:00';
        params.postback_date_to = getCurrentDate('yyyy-MM-dd') + ' 23:59:59';
    }

    return { ...params };
};

const prepareFilters = (params: any[]) => {
    for (const key in params) {
        if (key === 'postback_date_from') {
            params[key] = `${params[key]} 00:00:00`;
        }
        if (key === 'postback_date_to') {
            params[key] = `${params[key]} 23:59:59`;
        }
    }
};

return { __sfc: true,getHeaders, getFormattedItems, headers, isLoading, offset, total, route, constructor, preparedItems, tableComp, changePageFromConstructor, changePage, getReport, isExportLoading, exportPostbacks, getParams, prepareFilters, BaseTable, ListLayout, PostbacksConstructor, ReloadButton, DownloadButton }
}

})